import React, { Component } from 'react';
import { Grid,Row,Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import './Faq.css';

class Faq extends Component {
  render() {
    document.title = 'FAQ - NaleyCards'
    return (
      <Grid fluid>
      <Row>
        <Col xs={0} sm={0} md={0} lg={2}></Col>
        <Col xs={12} sm={12} md={12} lg={10}><h3>FAQ</h3></Col>
      </Row>
      <Row>
        <Col xs={0} sm={0} md={0} lg={2}></Col>
        <Col xs={12} sm={12} md={12} lg={10}>
        <span className="q">What is Naleycards?</span><br />
This is not a e-greeting cards or digital cards website.
We mail your love via personalised wishes which printed at real greeting card. <Link to="/cards">Choose a card now!</Link><br />
<br />
<span className="q">How do you mail the cards?</span>< br />
We mail the cards by Pos Malaysia FlexiPrepaid . Postage charges RM4.50 is included.<br />
<br />
<span className="q">What are the dimension of your card?</span><br />
Folded vertical 114x155mm.<br />
<br />
<span className="q">What is the turnaround time for my order?</span><br />
Once the order is submitted, we process and mail the cards within 1-2 business days.<br />
<br />
<span className="q">How long does it take for my card to reach my recipient?</span><br />
<Row>
<Col xs={7} sm={4} md={4} lg={4} key="col1">Within state (Peninsular Malaysia)</Col>
<Col xs={5} sm={3} md={3} lg={3} key="col2">Up to 3 – 4 days</Col>
</Row>
<Row>
<Col xs={7} sm={4} md={4} lg={4} key="col3">State-to-state (Peninsular Malaysia)</Col>
<Col xs={5} sm={3} md={3} lg={3} key="col4">Up to 4 – 5 days</Col>
</Row>
<Row>
<Col xs={7} sm={4} md={4} lg={4} key="col5">Peninsular to East Malaysia (vice versa)</Col>
<Col xs={5} sm={3} md={3} lg={3} key="col6">Up to 7 – 8 days</Col>
</Row>
<br />
<span className="q">Can I track my card?</span><br />
You can track your order via Pos Laju Track & Trace using the code provided by us. However, we will update you on the delivery status.<br />
<br />
<span className="q">How do I cancel or refund my order?</span><br />
Sorry about that. We are not able to cancel or refund the order.
However, if the recipients do not receive the card after 14 working days you can email us at hello@naleycards.com and we will resend the card.<br />

<br />
<span className="q">How can I view what cards I have sent?</span><br />
After payment made, payment details shown, click back to merchant. You can view the cards you have purchased under <Link to="/purchases">Purchased</Link> page.<br />
<br />
<span className="q">Can I buy a box of cards without message?</span><br />
Yes, you can send blank card to yourself.<br />
<br />
<span className="q">What are your box of cards shipping rate?</span><br />
Please emails us at hello@naleycards.com<br />
<br />
<span className="q">Will you print my message in other language other than English?</span><br />
Yes. Bahasa Malaysia and Chinese.<br />
<br />
<span className="q">Do you also sell ecards?</span><br />
No. We only send 100% printed cards by Pos Malaysia standard mail service.<br />
<br />
<span className="q">Do your cards green printing?</span><br />
The cards printings mainly is using eco-friendly ink.<br />
<br />
<span className="q">Can I edit the envelope?</span><br />
No. Once you have update the recipient info, we will write on the standard envelope and mail to recipients.<br />
<br />
<span className="q">Can I change the message fonts?</span><br />
No. We will add more font choises.<br />
<br />
<span className="q">What would cause an error when trying to use my credit card?</span><br />
Double check the card numbers, expire dates, CVV and name.<br />
<br />
<span className="q">What should I do if I made a mistake on my order?</span><br />
We can make changes for your order as long as it has not printed and mailed.  Please emails us at hello@naleycards.com.<br />
<br />
<span className="q">I am seeing error page, what should I do?</span><br />
Please emails us at hello@naleycards.com<br />
        </Col>
      </Row>
      </Grid>
    )
  }
}
export default Faq;
